import React from "react";
import styled from "styled-components";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import SelectGroup from "../Common/SelectGroup";
import CheckboxGroup from "../Common/CheckBoxGroup";
import { DISCOUNT_CRITERIA } from "../../Common/constants";

const messages = defineMessages({
  select: {
    id: "app.discountPeriodicity.select",
    description: "Select",
    defaultMessage: "Select",
  },
  discount: {
    id: "app.discountPeriodicity.discount",
    description: "Discount",
    defaultMessage: "Discount",
  },
  one: {
    id: "app.discountPeriodicity.one",
    description: "One",
    defaultMessage: "one",
  },
  two: {
    id: "app.discountPeriodicity.two",
    description: "Two",
    defaultMessage: "two",
  },
  three: {
    id: "app.discountPeriodicity.three",
    description: "Three",
    defaultMessage: "three",
  },
  ofEvery: {
    id: "app.discountPeriodicity.ofEvery",
    description: "of every",
    defaultMessage: "of every",
  },
  nights: {
    id: "app.discountPeriodicity.nights",
    description: "nights",
    defaultMessage: "nights",
  },
  type: {
    id: "app.discountPeriodicity.type",
    description: "Type",
    defaultMessage: "Type",
  },
  cheapest: {
    id: "app.discountPeriodicity.cheapest",
    description: "Descontar la noche más económica de la estancia",
    defaultMessage: "Descontar la noche más económica de la estancia",
  },
  mostExpensive: {
    id: "app.discountPeriodicity.mostExpensive",
    description: "Descontar la noche más cara de la estancia",
    defaultMessage: "Descontar la noche más cara de la estancia",
  },
  last: {
    id: "app.discountPeriodicity.last",
    description: "Descontar la última noche de la estancia",
    defaultMessage: "Descontar la última noche de la estancia",
  },
  repeat: {
    id: "app.discountPeriodicity.repeat",
    description: "Repeat",
    defaultMessage: "Repeat",
  },
});

const BlockStyled = styled.div`
  > label:first-child {
    margin-right: 30px;
  }

  display: flex;

  fieldset {
    padding-bottom: 0;
    margin-bottom: 0;
  }

  .form-group,
  label {
    display: flex;
    align-items: center;

    label,
    select {
      margin: 0 15px;
    }

    label {
      min-width: 50px;
    }

    label:first-child {
      margin: 0 15px 0 0;
    }
  }
`;

const MiddleBlockStyled = styled(BlockStyled)`
  margin: 15px 0 10px;
`;

function DiscountPeriodicity({ formValues, onChange, intl, disabled }) {
  const { discountedUnits, applyEveryNumberOfUnits, criteria, isRepeatable } = formValues;
  const applyEveryNumberOfUnitsOptions = {
    0: {
      label: intl.formatMessage(messages.select),
    },
  };

  for (let idx = parseInt(discountedUnits, 10) + 1; idx < 11; idx++) {
    applyEveryNumberOfUnitsOptions[idx] = {
      label: idx,
    };
  }
  return (
    <div>
      <BlockStyled>
        <label>
          <label>{<FormattedMessage {...messages.discount} />}</label>
          <SelectGroup
            value={discountedUnits}
            field={{
              disabled: disabled,
              fieldName: "discountedUnits",
              displayName: <FormattedMessage {...messages.discount} />,
              optionDisplay: {
                0: {
                  label: intl.formatMessage(messages.select),
                },
                1: {
                  label: "1",
                },
                2: {
                  label: "2",
                },
                3: {
                  label: "3",
                },
              },
            }}
            onChange={onChange}
          />
        </label>

        <label>
          <label>{<FormattedMessage {...messages.ofEvery} />}</label>
          <SelectGroup
            value={applyEveryNumberOfUnits}
            field={{
              disabled: disabled,
              fieldName: "applyEveryNumberOfUnits",
              displayName: <FormattedMessage {...messages.ofEvery} />,
              optionDisplay: applyEveryNumberOfUnitsOptions,
            }}
            onChange={onChange}
          />

          <FormattedMessage {...messages.nights} />
        </label>
      </BlockStyled>

      <MiddleBlockStyled>
        <label>
          <label>{<FormattedMessage {...messages.type} />}</label>
          <SelectGroup
            value={criteria}
            field={{
              disabled: disabled,
              fieldName: "criteria",
              displayName: <FormattedMessage {...messages.type} />,
              optionDisplay: {
                [DISCOUNT_CRITERIA.CHEAPEST]: {
                  label: intl.formatMessage(messages.cheapest),
                },
                [DISCOUNT_CRITERIA.MOST_EXPENSIVE]: {
                  label: intl.formatMessage(messages.mostExpensive),
                },
                [DISCOUNT_CRITERIA.LAST]: {
                  label: intl.formatMessage(messages.last),
                },
              },
            }}
            onChange={onChange}
          />
        </label>
      </MiddleBlockStyled>

      <BlockStyled>
        <label>{<FormattedMessage {...messages.repeat} />}</label>
        <CheckboxGroup
          value={isRepeatable}
          field={{
            disabled: disabled,
            fieldName: "isRepeatable",
            displayName: <FormattedMessage {...messages.repeat} />,
          }}
          onChange={onChange}
        />
      </BlockStyled>
    </div>
  );
}

export default injectIntl(DiscountPeriodicity);
